<template>
  <div id="oap-before-after" ref="beforeAfter" class="oap-before-after">
    <slot></slot>
  </div>
</template>

<script>
import { AnalyticsHandler } from '@Foundation';

export default {
  name: 'OapBeforeAfter',

  props: {
    shadeData: {
      type: Array,
      required: true,
    },
    taggingData: {
      type: Object,
      default: () => {
        return {
          event_name: 'before_after_module',
          category: '__pageCategory__',
        };
      },
    },
    onSlide: {
      type: Object,
      required: false,
      default: () => {
        return {
          action: 'slider',
        };
      },
    },
    onShadeClick: {
      type: Object,
      required: false,
      default: () => {
        return {
          action: 'shade_suggestion',
        };
      },
    },
    sliderAriaLabel: {
      type: String,
      default: 'Separator for the Before and After image',
    },
  },

  data() {
    return {
      selectedShadeIndex: 0,
      scrollPosition: 50,
      imgBeforeElement: null,
      imgAfterElement: null,
      thumbnails: null,
      slider: null,
      handle: null,
      labelBefore: null,
      labelAfter: null,
    };
  },

  computed: {
    selectedShade() {
      return this.shadeData[this.selectedShadeIndex];
    },
  },

  watch: {
    scrollPosition(val) {
      this.imgAfterElement.style.left = `-${val}%`;
      this.imgAfterElement.closest('.oap-before-after__img-wrapper--after').style.left = `${val}%`;
      this.handle.style.left = `${val}%`;

      if (val < 30) {
        this.labelBefore.style.opacity = '0';
      }

      if (val > 30) {
        this.labelBefore.style.opacity = '1';
      }

      if (val > 70) {
        this.labelAfter.style.opacity = '0';
      }

      if (val < 70) {
        this.labelAfter.style.opacity = '1';
      }
    },
  },

  mounted() {
    this.imgBeforeElement = this.$refs.beforeAfter.querySelector('.oap-before-after__img--before');
    this.imgAfterElement = this.$refs.beforeAfter.querySelector('.oap-before-after__img--after');
    this.thumbnails = this.$refs.beforeAfter.querySelectorAll('.oap-before-after__thumbnail');
    this.slider = this.$refs.beforeAfter.querySelector('.slider');
    this.handle = this.$refs.beforeAfter.querySelector('.handle');
    this.labelBefore = this.$refs.beforeAfter.querySelector('.oap-before-after__label--before');
    this.labelAfter = this.$refs.beforeAfter.querySelector('.oap-before-after__label--after');

    this.slider.addEventListener(
      'click',
      () => {
        this.handleAnalytics('slider');
      },
      {
        once: true,
      }
    );

    this.slider.addEventListener('input', (event) => {
      this.scrollPosition = event.target.value;
    });

    this.thumbnails.forEach((thumbnail, index) =>
      thumbnail.addEventListener('click', () => this.selectShade(thumbnail, index))
    );
  },

  methods: {
    handleAnalytics(trigger) {
      const additionalData = trigger === 'slider' ? this.onSlide : this.onShadeClick;

      AnalyticsHandler.getAnalyticsHandler().push({
        type: 'userActionEvent',
        ...this.taggingData,
        ...additionalData,
        label: this.selectedShade.tagging.eventLabel,
        product_info: this.selectedShade.tagging.productInfo,
      });
    },
    selectShade(thumbnail, index) {
      this.selectedShadeIndex = index;
      this.handleAnalytics(null, 'shade');

      this.thumbnails.forEach((thumb) => thumb.classList.remove('-selected'));
      thumbnail.classList.add('-selected');

      this.updatePicture(this.imgBeforeElement, this.shadeData[index].before);
      this.updatePicture(this.imgAfterElement, this.shadeData[index].after);
    },

    updatePicture(imgElement, imageData) {
      if (!imgElement || !imageData) return;

      const sources = imgElement.closest('picture').querySelectorAll('source');

      if (sources.length >= 2) {
        sources[0].srcset = imageData.src.lg;
        sources[1].srcset = imageData.src.sm;
      }

      imgElement.dataset.src = imageData.src.sm;
      imgElement.alt = imageData.altText;
    },
  },
};
</script>
